import { useEffect, useState } from "react";
import { api } from "./api";

// "Is the current session a platform admin?" Drives the visibility of
// the signup-queue nav item + route. Cached at the module level so the
// sidebar and the route guard share one network call; null while
// loading, boolean once resolved, false on any error (fail closed).
//
// In practice the cache only matters within one mounted SPA — sign-out
// (App.tsx / Pending.tsx) calls ``location.reload()`` which drops the
// module entirely. ``resetPlatformAdmin`` is still exposed so any
// future session-switch path that does NOT reload (e.g. a soft logout)
// can invalidate it explicitly rather than leaving the previous
// user's admin status sticky.
let cache: Promise<boolean> | null = null;

export function resetPlatformAdmin(): void {
  cache = null;
}

// api.logout() dispatches this; we react to it so a soft-logout path
// that doesn't reload the page still drops the cached admin status.
if (typeof window !== "undefined") {
  window.addEventListener("kyb-session-cleared", () => {
    cache = null;
  });
}

function load(): Promise<boolean> {
  if (!cache) {
    cache = api
      .me()
      .then((r) => r.is_platform_admin)
      .catch(() => false);
  }
  return cache;
}

export function usePlatformAdmin(): boolean | null {
  const [v, setV] = useState<boolean | null>(null);
  useEffect(() => {
    let alive = true;
    load().then((r) => {
      if (alive) setV(r);
    });
    return () => {
      alive = false;
    };
  }, []);
  return v;
}
